import { usePlainList, useUpdate } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Config } from "../types"

export function useConfig() {
  return usePlainList<Config>(`${API_URL}/admin/config`)
}

export function useConfigUpdate() {
  return useUpdate<Config>(`${API_URL}/admin/config`, {
    encode: "formdata",
  })
}

export function useConfigPartialUpdate() {
  return useUpdate<Config>(`${API_URL}/admin/config`, {
    encode: "formdata",
    method: "PATCH",
  })
}

